import React from "react";
import FieldMultilang from "./FieldMultilang";

export default function DescriptionMultilang({
  values,
  handleChange,
  availableLanguages = [],
  valuesLng = {},
  defaultLanguage = "",
  handleValuesLng,
}) {
  return (
    <FieldMultilang
      label="Descrizione"
      name="description"
      value={values.description}
      onChange={handleChange("description")}
      availableLanguages={availableLanguages}
      valuesLng={valuesLng.description}
      defaultLanguage={defaultLanguage}
      handleValuesLng={handleValuesLng && handleValuesLng("description")}
      fullWidth
      multiline
      hasFormat
      formatValue={values.descr_format}
      onFormatChange={handleChange("descr_format")}
    />
  );
}
